import { render } from "./commercial_ethics.vue?vue&type=template&id=03e67036&scoped=true"
import script from "./commercial_ethics.vue?vue&type=script&lang=js"
export * from "./commercial_ethics.vue?vue&type=script&lang=js"

import "./commercial_ethics.vue?vue&type=style&index=0&id=03e67036&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e67036"]])

export default __exports__